export const environment = {
  production: true,
  sitesService: 'https://gis.epa.guam.gov/arcgis/rest/services/Sites/FeatureServer/0',
  geometryService: 'https://gis.epa.guam.gov/arcgis/rest/services/Utilities/Geometry/GeometryServer',
  beachService: 'https://gis.epa.guam.gov/arcgis/rest/services/Beaches/FeatureServer/1',
  generatorService: 'https://gis.epa.guam.gov/arcgis/rest/services/StandbyGenerators/FeatureServer/0',
  baseMapService: 'https://gis.epa.guam.gov/arcgis/rest/services/Imagery/SatImageryMerged/MapServer',
  // baseMapService: 'http://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
  printUrl: 'https://gis.epa.guam.gov/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
  proxyUrl: `/api/esri-proxy/`,
  useProxy: true,
  jsapiUrl: 'https://js.arcgis.com/4.22/',
  // parcelLayerService: 'http://gis.guam.gov/arcgis/rest/services/EnvPro/EnvPro_LandParcels/MapServer/13',
  parcelLayerService: 'https://services2.arcgis.com/FPJlJZYRsD8OhCWA/ArcGIS/rest/services/25%20Parcel%20Layer%20Update%20with%2024%20Tax%20Roll/FeatureServer/0',
  gwaService: 'https://gis.epa.guam.gov/arcgis/rest/services/GuamWaterAuthorityData/MapServer',
  baseUrl: `/api`,
  local_token_endpoint: '',
  withCredentials: false,
  default_map_center: [144.8, 13.45],
  oauth_url: `/api/oauth2/login/google-oauth2/`,
  oauth_redirect_uri: `/`,
  local_service_endpoint: `/api`,
  api_host: `/`,
  geocoder_url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
  countryCode: 'US',
  epa_ppls_url: 'https://ordspub.epa.gov/ords/pesticides/cswu/ppls',
  webmapID: '1016b73568a447e1a9d7245ee65ba652'
};
